'use client';
import { MultiServicePreset } from '@/types';

import Button from '@/components/Button';
import SectionTitle from '@/components/SectionTitle';
import Subheader from '@/components/Subheader';
import Cards from '@/components/Cards';
import { useConfig } from '@/app/contexts/ConfigContext';
import { SERVICE_TYPES } from '@/helpers/enums';

import { CardDefinition } from '@/types';
import CustomLink from '@/components/CustomLink';

interface TextTwoSectionProps {
  items: CardDefinition[];
}

export default function TextTwoSection({ items }: TextTwoSectionProps) {
  const { wording, config, setConfig, updateWording, selectedLanguage } =
    useConfig();

  const handleTextTwoConfig = () => {
    if (config.multiService !== MultiServicePreset.AML) {
      return;
    }

    setConfig({
      ...config,
      serviceType: SERVICE_TYPES.ASTROLOGY,
    });
    updateWording(SERVICE_TYPES.ASTROLOGY, selectedLanguage);
  };

  return (
    <section className='sm:mb-32 mb-8'>
      <SectionTitle>{wording?.text2_section_title}</SectionTitle>
      <div className='flex items-end justify-between items-center mt-4'>
        <Subheader>{wording?.text2_section_subheader_text}</Subheader>
        <Button
          variant='secondary'
          className='!px-5 sm:!w-[295px]'
          themeBackgroundColor={config.theme.textColorDark}
          themeTextColor={config.theme.textColorLight}
        >
          <CustomLink href='/text2' onClick={handleTextTwoConfig}>
            {wording?.text2_section_button_more}
          </CustomLink>
        </Button>
      </div>
      <Cards items={items} />
    </section>
  );
}
